import React from 'react';
import { MessageTemplateType } from '~/types/models';
import MessageTemplateIcon from './MessageTemplateIcon';

export interface MessageTemplateRowProps {
  state: string;
  templateType: MessageTemplateType;
  name: string;
}

export const MessageTemplateRow = ({
  state,
  templateType,
  name,
}: MessageTemplateRowProps) => {
  return (
    <div className='flex flex-row gap-x-4'>
      <MessageTemplateIcon templateState={state} templateType={templateType} />
      {name}
    </div>
  );
};
